var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThIconLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_396_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 2.50637C1 1.84164 1.26406 1.20413 1.7341 0.7341C2.20413 0.264066 2.84163 3.34134e-06 3.50636 3.34134e-06H28.4909C28.8203 -0.000534684 29.1466 0.0639073 29.4511 0.18964C29.7556 0.315372 30.0323 0.499926 30.2653 0.732735C30.4984 0.965543 30.6833 1.24204 30.8093 1.54638C30.9354 1.85073 31.0002 2.17695 31 2.50637V27.4909C31.0004 27.8204 30.9357 28.1467 30.8099 28.4512C30.684 28.7557 30.4993 29.0324 30.2664 29.2654C30.0335 29.4985 29.7569 29.6833 29.4525 29.8093C29.148 29.9354 28.8218 30.0002 28.4923 30H3.50636C3.17711 30 2.85108 29.9351 2.5469 29.8091C2.24273 29.683 1.96637 29.4983 1.73361 29.2654C1.50086 29.0325 1.31627 28.7561 1.19039 28.4518C1.06452 28.1476 0.999821 27.8215 1 27.4923V2.50637ZM12.8745 11.4382H16.9368V13.4782C17.5232 12.3055 19.0232 11.25 21.2773 11.25C25.5986 11.25 26.6227 13.5859 26.6227 17.8718V25.8109H22.2495V18.8482C22.2495 16.4073 21.6632 15.03 20.1741 15.03C18.1082 15.03 17.2491 16.515 17.2491 18.8482V25.8109H12.8745V11.4382ZM5.37455 25.6241H9.74909V11.25H5.37455V25.6227V25.6241ZM10.375 6.56182C10.3832 6.93637 10.3166 7.3088 10.179 7.65725C10.0413 8.0057 9.83548 8.32314 9.5735 8.59096C9.31152 8.85877 8.99868 9.07156 8.65335 9.21683C8.30802 9.3621 7.93714 9.43694 7.5625 9.43694C7.18786 9.43694 6.81698 9.3621 6.47165 9.21683C6.12632 9.07156 5.81348 8.85877 5.5515 8.59096C5.28952 8.32314 5.08367 8.0057 4.94604 7.65725C4.8084 7.3088 4.74175 6.93637 4.75 6.56182C4.76619 5.82662 5.06962 5.12699 5.5953 4.61276C6.12098 4.09852 6.82712 3.81057 7.5625 3.81057C8.29788 3.81057 9.00402 4.09852 9.5297 4.61276C10.0554 5.12699 10.3588 5.82662 10.375 6.56182Z",
    fill: "#2F7BB5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_396_1524",
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_396_1524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_396_1524",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThIconLinkedin);
export default __webpack_public_path__ + "static/media/TH-Icon-Linkedin.24e673493c59a705405794af7e96f705.svg";
export { ForwardRef as ReactComponent };